import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, transition } from '@angular/animations';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { EditDialogService } from 'src/app/services/edit-dialog/edit-dialog.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EditModeService } from 'src/app/services/edit-mode/edit-mode.service';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { BuilderService } from 'src/app/services/builder/builder.service';
import { Router } from '@angular/router';
import { VerifyEmailFormComponent } from '../verify-email-form/verify-email-form.component';
import { VerifyService } from 'src/app/services/verify/verify.service';

@Component({
    selector: 'xqnr-edit-dialog',
    templateUrl: './edit-dialog.component.pug',
    styleUrls: ['./edit-dialog.component.scss'],
    animations: [
        trigger('showHide', [
            transition(':enter', []),
            transition(':leave', [])
        ])
    ],
    standalone: false
})
export class EditDialogComponent implements OnInit {
  @ViewChild(VerifyEmailFormComponent) verifyEmailForm: VerifyEmailFormComponent;

  emailSent = false;

  constructor(
    private backdrop: BackdropService,
    public editDialog: EditDialogService,
    private auth: AuthService,
    private editMode: EditModeService,
    private qs: QuestionnaireService,
    private builder: BuilderService,
    private router: Router,
    public verify: VerifyService
  ) {}

  ngOnInit() {
    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (!activeState) this.editDialog.hide();
    });
  }

  hideEditDialog() {
    this.editDialog.hide();
    this.backdrop.hide();
  }

  connectXrefAccount() {
    this.auth.authoriseOauthConnection();
  }

  handleEmailSubmit() {
    this.emailSent = true;
  }

  assignUserError = (res: any) => {
    console.error(res);
  };

  assignUserSuccess = (res: any) => {
    if (res.cloned)
      this.router.navigate([`/build/${res.id}`]);

    this.editMode.setEditMode(true);
    this.hideEditDialog();
  };

  handleCodeSubmit() {
    this.qs.assignUserToQuestionnaireImplicit(
      this.builder.questionnaire.id
    ).subscribe(
      this.assignUserSuccess,
      this.assignUserError
    );
  }

  handleResendCode() {
    this.emailSent = false;
  }
}
